import { useRef } from 'react'
import SVG from 'react-inlinesvg'
import { useTranslation } from 'react-i18next'
import { motion } from 'motion/react'
import { useContextPanels } from '../../contexts/panelsContext'
import { useContextSelectedMotifs } from '../../contexts/selectedMotifContext'
import { UIElement } from '../../types/UIElements'
import MotifListControl from '../GeneratorControls/MotifList'
import SideMenuButton from './SideMenuButton'
import SideMenuModal from './SideMenuModal'
import SideMenuNav from './SideMenuNav'
import SideMenuFooter from './SideMenuFooter'
import { contentVariants } from './menuAnimation'

const SideMenu = () => {
  const { isPanelOpen, toggleSideMenu } = useContextPanels()
  const { selectedMotifs } = useContextSelectedMotifs()
  const { t } = useTranslation()
  // the panel grows out of this button
  const menuButtonRef = useRef<HTMLButtonElement>(null)
  const isOpen = isPanelOpen(UIElement.SIDEMENU)

  return (
    <>
      <SideMenuModal isOpen={isOpen} onClose={toggleSideMenu} buttonRef={menuButtonRef}>
        <motion.button
          type="button"
          aria-label={t('sideMenu.close')}
          className="absolute right-0 top-0 flex size-10 items-center justify-center rounded-full border-none bg-black95 p-0 text-white tall-xxs:size-[50px] xs:tall-sm:right-5 xs:tall-sm:top-5 sm:size-[70px] md:size-20 xl:right-6 xl:top-6"
          variants={contentVariants}
          onClick={toggleSideMenu}
        >
          <SVG className="w-[45%] sm:w-[40%] xl:max-h-[35px] xl:min-w-10" src="/icons/x.svg" />
        </motion.button>
        <SideMenuNav />
        <SideMenuFooter />
      </SideMenuModal>
      <SideMenuButton ref={menuButtonRef} />
      {selectedMotifs.length ? <MotifListControl /> : null}
    </>
  )
}

export default SideMenu
